import type { CheckoutSession } from "@/types/Payment";
import Api from "./Api";

export class PaymentsApi {
  static async createCheckoutSession(formId: string): Promise<CheckoutSession> {
    const { data } = await Api.post<CheckoutSession>(`/form-submission/${formId}/payment/`);
    return data;
  }
}
